import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An unexpected error occurred';

      if (error.error) {
        if (typeof error.error.message === 'string') {
          errorMessage = error.error.message;
        } else if (Array.isArray(error.error.errors) && error.error.errors.length > 0) {
          errorMessage = error.error.errors.join(', ');
        }
      }

      if (error.status === 403) {
        toastService.error('Permission Denied', 'You do not have privilege to perform this action.');
      } else if (error.status === 404) {
        toastService.error('Not Found', errorMessage || 'Requested resource could not be found.');
      } else if (error.status === 409) {
        toastService.warning('Conflict', errorMessage || 'Conflict occurred with existing data.');
      } else if (error.status === 422) {
        toastService.error('Validation Error', errorMessage || 'Form validation failed.');
      } else if (error.status >= 500) {
        toastService.error('Server Error', 'Internal server error. Please try again later.');
      }

      return throwError(() => error);
    }),
  );
};
